import React from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../../../common-components";

const InviteCard = ({ username, roles, status, createdOn }) => {
  return (
    <div
      style={{
        height: 210,
        width: "100%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            height: "90%",
            width: "90%",
            backgroundColor: colors.white,
            borderRadius: 10,
            WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
            display: "flex",
            flexDirection: "row",
            position: "relative",
          }}
        >
          <div style={{ marginLeft: 20, marginTop: 10 }}>
            <TextInputField
              labelTitle={"USERNAME"}
              mini={true}
              readOnly={true}
              value={username}
            />

            <TextInputField
              labelTitle={"CREATED ON"}
              mini={true}
              readOnly={true}
              value={createdOn}
            />
          </div>
          <div style={{ height: "100%", marginLeft: 10 }}>
            <div
              style={{
                marginTop: 20,
                marginLeft: 20,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              ---- ROLES ----
            </div>
            <div
              style={{
                marginTop: 10,
                marginLeft: 20,
                // fontWeight: "bold",
                fontSize: 14,
              }}
            >
              {roles}
            </div>
            <div
              style={{
                marginTop: 20,
                marginLeft: 20,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              ---- STATUS ----
            </div>
            <div
              style={{
                marginTop: 10,
                marginLeft: 20,
                // fontWeight: "bold",
                fontSize: 14,
              }}
            >
              {status}
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              // bottom: -20,
              right: 20,
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <BaseButtons
              label={"RESEND INVITE"}
              borderRadius={8}
              backgroundColor={colors.greenDark}
              width={250}
            />

            <BaseButtons
              label={"DELETE INVITE"}
              borderRadius={8}
              backgroundColor={colors.orangeDark}
              width={220}
            />
          </div>
        </div>
      </div>
      {/* <div
        style={{
          flex: 0.5,
          height: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <div
          style={{
            height: "90%",
            width: "90%",
            backgroundColor: colors.greenLight,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            WebkitBoxShadow: "10px 5px 15px -1px #00000070",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 16,
              marginTop: 10,
              marginLeft: 20,
              color: colors.white,
            }}
          >
            LINKED USER
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: -20,
              }}
            >
              <TextInputField
                labelTitle={"FIRST NAME"}
                mini={true}
                readOnly={true}
                size={150}
                invert={true}
              />
              <TextInputField
                labelTitle={"LAST NAME"}
                mini={true}
                readOnly={true}
                size={150}
                invert={true}
              />
            </div>
            <div style={{ marginTop: -20 }}>
              <TextInputField
                labelTitle={"CELL NUMBER"}
                mini={true}
                readOnly={true}
                size={150}
                invert={true}
              />
              <TextInputField
                labelTitle={"EMAIL"}
                mini={true}
                readOnly={true}
                size={150}
                invert={true}
              />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default InviteCard;
